import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'user', en);

const UserListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Users',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.USER,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/user/list',
      component: React.lazy(() => import('./UserList')),
    },
  ],
};

export default UserListConfig;
